import Dispatcher from '../../dispatcher';
import { ReduceStore } from 'flux/utils';
import { actionTypes } from '../../constants/action_types';
import { actions } from '../../constants/sidebar/actions';

const { SIDEBAR_ACTION } = actionTypes;

const {
    SHOW_FITTING_STATION_DETAILS,
    HIDE_FITTING_STATION_DETAILS
} = actions;

class GeneralClass extends ReduceStore {
    getInitialState() {
        return {
            fsDetailsVisible: true,
        };
    }

    reduce( state, { source, action } ) {
        const { type } = action;

        return (
            source === SIDEBAR_ACTION
                ? this.reduceSidebarAction( state, action )
                : state
        );
    }

    reduceSidebarAction( state, { type }) {
        return (
            type === SHOW_FITTING_STATION_DETAILS
                ? this.handleShowFsDetailsAction( state )

            : type === HIDE_FITTING_STATION_DETAILS
                ? this.handleHideFsDetailsAction( state )

            : state
        );
    }

    handleShowFsDetailsAction( state ) {
        if ( !state.fsDetailsVisible ) {
            state.fsDetailsVisible = true;
            this.__emitChange();
        }

        return state;
    }

    handleHideFsDetailsAction( state ) {
        if ( state.fsDetailsVisible ) {
            state.fsDetailsVisible = false;
            this.__emitChange();
        }

        return state;
    }
}

export const General = new GeneralClass( Dispatcher );
